import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = '';

        if (error.error instanceof ErrorEvent) {
          // Error del lado del cliente
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // Error del lado del servidor
          if (error.status === 400) {
            // Errores de validación
            if (error.error?.message) {
              if (Array.isArray(error.error.message)) {
                errorMessage = error.error.message.join(', ');
              } else {
                errorMessage = error.error.message;
              }
            } else {
              errorMessage = 'Datos inválidos';
            }
          } else if (error.status === 404) {
            errorMessage = 'Recurso no encontrado';
          } else if (error.status === 409) {
            errorMessage = 'Conflicto: El recurso ya existe';
          } else if (error.status === 500) {
            errorMessage = 'Error interno del servidor';
          } else if (error.status === 0) {
            errorMessage = 'No se puede conectar con el servidor. Verifica que esté ejecutándose.';
          } else {
            errorMessage = `Error ${error.status}: ${error.error?.message || 'Error desconocido'}`;
          }
        }

        console.error('HTTP Error:', {
          status: error.status,
          message: errorMessage,
          url: error.url,
          error: error.error
        });

        return throwError(() => ({
          status: error.status,
          message: errorMessage,
          originalError: error
        }));
      })
    );
  }
}